import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../services/api";
import axiosPrivate from "../../services/axios/axiosPrivate";
import { toast } from "react-toastify";

export const getExportData = createAsyncThunk('JoiningDetails/exportData',
  async (userId, { rejectWithValue }) => {
    console.log('getExportDatauserid', userId)
    try {
      const response = await axiosPrivate.get(`${api.getExportData}${userId}`, {
        responseType: 'blob', 
      });

      return response.data; 

    } catch (error) {
      toast.error("Failed to export data", {
        className: "toast-error-custom",
      });
      return rejectWithValue(error?.response?.data?.message || "Unable to connect to server");
    }
  }
);

const getExportDataSlice = createSlice({
  name: 'exportData',
  initialState: {
    exportData: {},
    status: 'idle',
    loading: false,
    error: null
  },
  reducers: {},
  extraReducers: (builders) => {
    builders
      .addCase(getExportData.pending,
        (state) => {
          state.status = 'loading';
          state.loading = true;
          state.error = null;
        })
      .addCase(getExportData.fulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.loading = false;
          state.exportData = action.payload;
        })
      .addCase(getExportData.rejected,
        (state, action) => {
          state.status = 'failed';
          state.loading = false;
          state.error = action.payload;
        }
      )
  }
})

export default getExportDataSlice.reducer;